 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import BACKCOVERTEXT from '@/components/BackCoverText'
 import INTRODUCTION from '@/components/Introduction'
 import DEARREADER from '@/components/DearReader'
 import TITLEPAGE from '@/components/TitlePage'
 import ABOUTTHEAUTHOR from '@/components/AbouttheAuthor'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import CHAPTERONE from '@/components/ChapterOne'
 import CHAPTERTWO from '@/components/ChapterTwo'
 import CHAPTERTHREE from '@/components/ChapterThree'
 import CHAPTERFOUR from '@/components/ChapterFour'
 import CHAPTERFIVE from '@/components/ChapterFive'
 import CHAPTERSIX from '@/components/ChapterSix'
 import CHAPTERSEVEN from '@/components/ChapterSeven'
 import CHAPTEREIGHT from '@/components/ChapterEight'
 import CHAPTERNINE from '@/components/ChapterNine'
 import CHAPTERTEN from '@/components/ChapterTen'
 import CHAPTERELEVEN from '@/components/ChapterEleven'
 import CHAPTERTWELVE from '@/components/ChapterTwelve'
 import CHAPTERTHIRTEEN from '@/components/ChapterThirteen'
 import CHAPTERFOURTEEN from '@/components/ChapterFourteen'
 import CHAPTERFIFTEEN from '@/components/ChapterFifteen'
 import CHAPTERSIXTEEN from '@/components/ChapterSixteen'
 import CHAPTERSEVENTEEN from '@/components/ChapterSeventeen'
 import CHAPTEREIGHTEEN from '@/components/ChapterEighteen'
 import CHAPTERNINETEEN from '@/components/ChapterNineteen'
 import CHAPTERTWENTY from '@/components/ChapterTwenty'
 import EXCERPTFROMTEXASBORNBYDIANAPALMER from '@/components/ExcerptfromTexasBornbyDianaPalmer'
 import BPASPECIALEDITION from '@/components/BPASpecialEdition'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/ChapterOne",
 			"name" : "ChapterOne",
 			"component" : CHAPTERONE
 		},
 		{
 			"path" : "/ChapterTwo",
 			"name" : "ChapterTwo",
 			"component" : CHAPTERTWO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js